import { SalesAgreementEdit } from '@features/TimberBuyer/SalesAgreements/Edit/SalesAgreementEdit'
import { createFileRoute } from '@tanstack/react-router'
import { t } from '@utils/i18n-to-migrate'

const SalesAgreementEditRoute: React.FC = () => {
  const { timberBuyerId } = Route.useParams()

  return <SalesAgreementEdit timberBuyerId={timberBuyerId} />
}

export const Route = createFileRoute(
  '/timberbuyer/$timberBuyerId/sales-agreements/$salesAgreementId/edit/',
)({
  component: SalesAgreementEditRoute,
  staticData: {
    breadcrumb: t('timberbuyer-salesagreements-edit.breadcrumb'),
  },
})
